import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import WishlistToggleButton from '~/shared/components/WishlistToggleButton';
import { useSession } from '~/techstyle-shared/redux-core';

const FavoriteButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px; /* fully rounded */
  z-index: 1;
`;

const ProductCardFavoriteButton = ({ product }) => {
  const { isLoggedIn } = useSession();

  if (!isLoggedIn) {
    return null;
  }

  return (
    <FavoriteButtonWrapper>
      <WishlistToggleButton
        data-cnstrc-btn="add-to-favorites"
        product={product}
      />
    </FavoriteButtonWrapper>
  );
};

ProductCardFavoriteButton.propTypes = {
  product: PropTypes.object.isRequired,
};

export default ProductCardFavoriteButton;
